"use client";

import * as Avatar from "@radix-ui/react-avatar";

import { cn } from "@punchup/utils/cn";

interface Props {
  fallbackText?: string;
  imageSrc?: string;
  displayName?: string;
  className?: string;
  isNotPunchupComedian?: boolean;
  isFollowed?: boolean;
  size?: "sm" | "md" | "lg" | number;
}

export default function SuggestedComedianAvatar({
  fallbackText = "",
  imageSrc = undefined,
  displayName = "Comedian",
  className,
  isNotPunchupComedian = false,
  isFollowed = false,
  size = "sm",
}: Props) {
  const isPunchupComedian = !isNotPunchupComedian;

  return (
    <Avatar.Root
      className={cn(
        "flex flex-col items-center justify-center w-14 h-14 font-bold bg-light-orange rounded-full overflow-hidden shadow-sm ring-primary",
        imageSrc ? "border-2 border-primary" : "border border-gray-300/40",
        isPunchupComedian && "ring-primary",
        isFollowed && "ring-primary",
        size === "sm" && "w-14 h-14",
        size === "md" && "w-16 h-16",
        size === "lg" && "w-20 h-20",
        className
      )}
      style={{
        width: typeof size === "number" ? size : undefined,
        height: typeof size === "number" ? size : undefined,
      }}
    >
      <Avatar.Image
        className="object-cover w-full h-full rounded-full"
        src={imageSrc} // falls back to display the component below, when undefined
        alt={displayName}
      />
      <Avatar.Fallback
        className="font-medium text-[15px] bg-light-orange text-primary"
        delayMs={600}
      >
        {fallbackText}
      </Avatar.Fallback>
    </Avatar.Root>
  );
}
